import * as React from "react";
import { IconProps } from "ztypes/icon-props";

const IconInfo: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00001 2.19995C4.79676 2.19995 2.20001 4.7967 2.20001 7.99995C2.20001 11.2032 4.79676 13.8 8.00001 13.8C11.2033 13.8 13.8 11.2032 13.8 7.99995C13.8 4.7967 11.2033 2.19995 8.00001 2.19995ZM1.20001 7.99995C1.20001 4.24442 4.24448 1.19995 8.00001 1.19995C11.7555 1.19995 14.8 4.24442 14.8 7.99995C14.8 11.7555 11.7555 14.8 8.00001 14.8C4.24448 14.8 1.20001 11.7555 1.20001 7.99995ZM8.00001 6.90002C8.44184 6.90002 8.80001 7.2582 8.80001 7.70002V11.3C8.80001 11.7419 8.44184 12.1 8.00001 12.1C7.55818 12.1 7.20001 11.7419 7.20001 11.3V7.70002C7.20001 7.2582 7.55818 6.90002 8.00001 6.90002ZM8.90002 5.30002C8.90002 5.79708 8.49708 6.20002 8.00002 6.20002C7.50296 6.20002 7.10002 5.79708 7.10002 5.30002C7.10002 4.80297 7.50296 4.40002 8.00002 4.40002C8.49708 4.40002 8.90002 4.80297 8.90002 5.30002Z"
          fill="#3D3D3D"
        />
      </g>
    </svg>
  );
};

export default IconInfo;
